"use client";

import { useEffect, useState } from "react";
import { PasskeyLoginButton } from "@/components/passkey-login-button";

function FieldPlaceholder() {
  return <div className="field text-base min-h-12" aria-hidden />;
}

export function LoginForm({
  callbackUrl,
  failed,
  schoolOnly,
}: {
  callbackUrl?: string;
  failed?: boolean;
  schoolOnly?: boolean;
}) {
  const [username, setUsername] = useState("");
  const [fieldsReady, setFieldsReady] = useState(false);

  useEffect(() => {
    setFieldsReady(true);
  }, []);

  return (
    <div className="card mt-8 space-y-4 p-6">
      <form method="post" action="/api/login" className="space-y-4" suppressHydrationWarning>
        {callbackUrl ? <input type="hidden" name="callbackUrl" value={callbackUrl} /> : null}
        <div className="space-y-2">
          <label htmlFor="username">Gebruikersnaam of schoolmail</label>
          {fieldsReady ? (
            <input
              id="username"
              name="username"
              className="field text-base"
              autoComplete="username webauthn"
              required
              placeholder="voornaam.naam@lln.athena-heule.be"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          ) : (
            <FieldPlaceholder />
          )}
        </div>
        <div className="space-y-2">
          <label htmlFor="password">Wachtwoord</label>
          {fieldsReady ? (
            <input
              id="password"
              name="password"
              type="password"
              className="field text-base"
              autoComplete="current-password"
              required
            />
          ) : (
            <FieldPlaceholder />
          )}
        </div>
        {schoolOnly ? (
          <p className="text-[var(--danger)]">Het klasbord kan alleen op school aanmelden.</p>
        ) : null}
        {failed ? (
          <p className="text-[var(--danger)]">Aanmelden mislukt. Controleer je gegevens of vraag de leerkracht om hulp.</p>
        ) : null}
        <button className="btn btn-primary w-full min-h-12" type="submit">
          Aanmelden
        </button>
      </form>
      <a className="btn btn-ghost w-full min-h-12" href="/wachtwoord-vergeten">
        Wachtwoord vergeten?
      </a>
      <div className="relative py-1 text-center text-sm text-[var(--muted)]">
        <span className="bg-[var(--bg-elev)] px-2">of</span>
      </div>
      <PasskeyLoginButton username={username} callbackUrl={callbackUrl} />
    </div>
  );
}
